/*
  Mixin used to manage natural or logical language
*/
export default  {
  computed: {
    showLogicalLanguage() {
      return this.$store.state.showLogicalLangage;
    },
  },
};
